import {Component, Input} from "@angular/core";
import {ILeaderboardRow} from "../../../../shared/interfaces/DTOs/Response/IGetExercisesLeaderboardRes";
import {DecimalPipe} from "@angular/common";

@Component({
  selector: "app-average-comparison",
  templateUrl: "./average-comparison.component.html",
  styleUrls: ["./average-comparison.component.scss"],
  imports: [
    DecimalPipe
  ],
  standalone: true
})
export class AverageComparisonComponent {
  @Input() leaderboardRow: ILeaderboardRow;
}
